import { Routes } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { OrdersComponent } from './orders.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { EventsComponent } from './events/events.component';
import { AuthGuard } from '../services/index';

export const orderRoutes: Routes = [
    { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard]  },
    { path: 'order/:id', component: OrderDetailComponent, canActivate: [AuthGuard]  },
    { path: 'events/:id', component: EventsComponent, canActivate: [AuthGuard]  }
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/order.routes.ts